import hodViewTpl from './views/hodView.html';
import './profileSetting.scss';
import hodViewCtrl from './controllers/hodViewController';


const name = 'hodView';
var module = angular.module("app.hodView", [

]).component(name, {
    template: hodViewTpl,
    controllerAs: name,
    controller: hodViewCtrl
}).controller('hodViewCtrl', hodViewCtrl);

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('hodView', {
            parent: 'app',
            url: '/hodView',
            views: {
                '@': {
                    template: hodViewTpl,
                    controller: hodViewCtrl,
                    controllerAs: 'hodView'
                }
            }
        })
}); */


// WEBPACK FOOTER //
// ./src/app/profileSetting/hodViewModule.js